export enum UserTypeValue {
  NoRole = 0,
  Designer = 1,
  Dashboard = 2,
  Report = 3,
}
